export const en = {
  common: {
    pageTitle: 'eHR.bg - Digital employment records',
    fullName: 'eHR (Digital Employment Records)',
    success: 'Success!',
    error: 'Error!',
    loading: 'Loading',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    saveAndContinue: 'Save and continue',
    saveAndSign: 'Save and sign',
    ok: 'OK',
    back: 'Back',
    edit: 'Edit',
    redact: 'Redact document',
    and: 'and',
    from: 'from',
    for: 'for',
    yes: 'Да',
    no: 'Не',
    preview: 'Preview',
    delete: 'Delete',
    noPermission: 'Not enough permissions',
    addPosition: '+ Add position',
    home: 'Home',
    error404: 'Page could not be found or an error has occurred.',
    switchedMode: 'Switched to user mode',
    with: 'with',
    import: 'Import',
    downloadTemplate: 'Download template',
    downloadErrorTemplate: 'Свали файл със сгрешените данни',
    importSuccess: 'Успешно импортирани - {{count}}.',
    importFailed: 'Неуспешно импортирани - {{count}}.',
    row: 'Row',
    copyToClipboard: 'Copy with a single click',
    requestAndSign: 'Send request and sign',
    notExistingUser: 'Not existing user',
    currentlyUploadedFiles: 'Currently uploaded files',
    has: 'Has',
    hasNot: 'Has not',
    cacheVersion: 'Cache cleared successfully, you are currently using version:',
    create: 'Create',
    viewEmpDocs: 'View employee documents',
    createEmpDoc: 'Create an employee document',
  },
  biss: {
    generalError:
      'An error occurred while performing a signature. Please try restarting BISS, your browser or computer. If the errors continue, please contact us as support@ehr.bg or +359 882 005 545.',
    checkOption:
      'please confirm your QES token is connected to the computer (try other USB ports too). Also make sure your QES is still valid, or try to choose an alternative option from BISS -> "Select certificate". If the issue persists, please contact us as support@ehr.bg or +359 882 005 545.',
    noResponse:
      'Error connecting to BISS, please make sure it is running. If it is - please try turning it off and on again, and make sure it is up to date. If the issue persists, please contact us as support@ehr.bg or +359 882 005 545.',
  },
  editor: {
    splitText: 'Split text to block',
  },
  auth: {
    login: {
      title: 'Log in',
      email: 'E-mail',
      emailPlaceholder: 'Enter e-mail',
      pass: 'Password',
      passPlaceholder: 'Enter password',
      forgottenPassword: 'Forgotten password?',
      code: 'Verification code',
      login: 'Log in',
    },
    forgottenPassword: {
      title: 'Forgotten password',
      email: 'Enter e-mail:',
      emailPlaceholder: 'E-mail',
      send: 'Send',
    },
    resetPassword: {
      title: 'Reset password',
      pass: 'Password',
      passHint:
        'Must be at least 10 characters long and contain lowercase ' +
        'letter, uppercase letter, a number and a special symbol.',
      confirmPass: 'Confirm password',
      change: 'Change',
      success: 'Your password has been updated.',
    },
    accountActivation: {
      title: 'Account validation',
      pass: 'Password',
      passHint:
        'Must be at least 10 characters long and contain lowercase ' +
        'letter, uppercase letter, a number and a special symbol.',
      confirmPass: 'Confirm password',
      validate: 'Validate',
      resendEmailActivation: 'Resend e-mail activation',
      resendActivationSuccessMsg: 'The account activation message was sent successfully.',
      gotoLogin: 'Go to login',
    },
    twoFA: {
      googleAuth: 'Two-factor authentication with Google Authenticator',
      microsoftAuth: 'Microsoft Two-factor Authentication',
    },
  },
  candidateApplication: {
    title: 'Candidate Application Form',
    firstName: 'First Name',
    firstNameEn: 'First Name',
    lastName: 'Last Name',
    lastNameEn: 'Last Name',
    email: 'Email',
    egn: 'Personal identification number',
    address: 'Постоянен адрес',
    address_en: 'Permanent address',
    department: 'Department',
    selectDepartment: 'Select Department',
    submit: 'Submit Application',
    successMessage: 'The applicant has been added successfully (if there is no user with a duplicate email).',
    errorLoadingOptions: 'Error loading department options.',
    otherInformation: 'Other Information',
    otherInformationEn: 'Other Information',
    acceptTermsRequired: 'You must accept the terms.',
    acceptTermsPrefix: 'I accept the terms of',
    termsTitle: 'Consent for Personal Data Processing',
  },
  form: {
    select: 'Select',
    selectAll: 'Select all',
    removeAll: 'Remove all',
    selected: '{{count}} selected',
    selected_plural: '{{count}} selected',
    create: 'Create',
    noOptions: 'No options',
    isRequired: 'Field is required.',
    invalidEmail: 'Invalid e-mail address.',
    invalidFormat: 'Invalid format.',
    invalidWholeNumber: 'Number must be a whole number.',
    invalidValue: 'Choose valid value.',
    passMismatch: "Passwords don't match.",
    tooShort: 'Too short',
    weak: 'Weak',
    okay: 'Okay',
    good: 'Good',
    strong: 'Strong',
    time: 'time',
    fillWithValidData: 'Fill in all required fields correctly.',
  },
  table: {
    typeFilter: 'Type',
    categoryFilter: 'Category',
    groupFilter: 'Group',
    creatorFilter: 'Author',
    userFilter: 'Employee',
    createdAtFilter: 'Created on',
    leavePeriod: 'Month and year',
    statusFilter: 'Status',
    activeStatus: 'Active',
    inactiveStatus: 'Inactive',
    releasedStatus: 'Released',
    search: 'Search ...',
    firstPage: 'First page',
    prevPage: 'Previous page',
    nextPage: 'Next page',
    morePages: 'More pages',
    lastPage: 'Last page',
    allResultsShown: 'Showing {{total}} result',
    allResultsShown_plural: 'Showing {{total}} results',
    resultsShown: 'Showing {{startIndex}} - {{endIndex}} of {{total}} results',
    actions: 'Actions',
    noResults: 'No results found',
    sort: 'Sort',
    filterWarning:
      'Filters are applied. You may not see the full information. Please remove them manually or reload the page.',
  },
  menu: {
    documentTemplates: 'Document templates',
    operators: 'Operators',
    clients: 'Clients',
    fields: 'Fields',
    segments: 'Segments',
    createDocument: 'Create document',
    documents: 'Documents',
    myDocuments: 'My documents',
    structure: 'Structure',
    reports: 'Reports',
    workMode: 'Work mode: ',
    switchWorkMode: 'Switch to ',
    settings: 'Settings',
    twoFA: 'Two-factor authentication',
    support: 'Support',
    aboutUs: 'About Us',
    privacyPolicy: 'Privacy Policy',
    trainingMaterials: 'Training materials',
    logout: 'Log out',
    leaves: 'Leaves',
    myLeaves: 'My leaves',
    colleaguesLeaves: 'Colleagues leaves',
    hourlyAbsences: 'Hourly absences',
    healthAndSafetyTraining: 'H&S training',
    workTrips: 'Work trips',
  },
  addToHomescreen: {
    title: 'Add to Home Screen',
    install: 'Install on your device',
    description: 'This website has app functionality. Add it to your home screen to use it as an app.',
    description2:
      'The app is already installed or the feature is not supported by your browser. Use the following instructions:',
    iosInstallInstructions1: '1) Press the Share button at the bottom of your screen',
    iosInstallInstructionsChrome1: '1) Press the Share button at the top-right of your screen',
    iosInstallInstructions2: '2) Press "Add to Home Screen"',
    iosInstallInstructions3: '3) Press "Add" in the top right corner',
    androidInstallInscructions1: "1) Press the 'Menu' button",
    androidInstallInscructions2: "2) Press 'Add to Home screen'",
  },
  newVersionAvailable: {
    title: 'New version available',
    description: 'A new version of the app is available. Please refresh the page.',
    refresh: 'Refresh',
    later: 'Later',
  },
  documents: {
    title: 'Manage documents',
    received: 'Received',
    awaiting: 'To sign/send',
    sent: 'Sent',
    archived: 'Archived',
    file: 'File',
    trash: 'Trash',
    internalDoc: 'Internal document',
    externalDoc: 'External document',
    approvals: 'Approvals',
    signatures: 'Signatures',
    docName: 'Document name',
    packageName: 'Package name',
    packageName2: 'Наименование на пакет документи',
    docName_lang2: 'Име на документа',
    eSign: 'E-sign',
    eSignSubtitle: 'Loading signature certificates',
    docActivity: 'Document activity to ',
    table: {
      name: 'Name',
      moreDetails: 'More details',
      expectedActions: 'Expected actions:',
      noExpectedActions: 'No expected actions',
      category: 'Category',
      author: 'Author',
      employee: 'Employee',
      group: 'Group',
      createdAt: 'Created on',
      send: 'Send',
      archive: 'Archive',
      preview: 'Preview/Print',
      history: 'Activity',
      docNumber: 'Number',
      totalDocuments: 'Total documents',
      approval: 'Approval/verification',
      approve: 'Approve/verify',
      signing: 'Signing',
      actionsEmployer: 'Actions by employer:',
      approvedByEmployer: 'Approved by employer',
      signedByEmployer: 'Signed by employer',
      actionsEmployee: 'Actions by employee:',
      approvedByEmployee: 'Approved by employee',
      signedByEmployee: 'Signed by employee',
      approvedSignedByEmployee: 'By employee',
      signedAndApprovedByEmployee: 'Signed and approved by employee',
      signedAndAprrovedByEmployer: 'Signed and approved by employer',
      sign: 'Sign',
      signOnly: 'Sign only',
      signAndExitInterview: 'Sign and open exit interview',
      verifyAndSign: 'Verify and Sign',
      approveAndSign: 'Approve and Sign',
      reject: 'Reject',
      actionComplete: 'Action is completed',
      actionWaiting: 'Action required',
      actionRejected: 'Action is rejected',
      rejectedWithReason: 'Rejected with reason: {{reason}}',
      lastUpdate: 'Last update',
      actionNotRequired: 'Action is not required',
      actionNotRequiredYet: 'Action is not required yet',
      actionReview: 'Review Leave',
      modalReviewPrompt: 'Сигурни ли сте, че искате да маркирате този болничен като проверен?',
      previewDoc: 'Document preview',
      docActivity: 'Document activity',
      confirmDocHeading: 'Are you sure?',
      confirmSendDocHeading: 'Send',
      confirmArchiveDocHeading: 'Move to Archive',
      confirmDeleteDocHeading: 'Move to Trash',
      confirmHardDeleteDocHeading: 'Delete document',
      confirmApproveDocMsg: 'Do you want to approve this document?',
      confirmApproveDocMsg_plural: 'Do you want to approve these documents?',
      confirmSendDocMsg_plural: 'Do you want to send these documents?',
      confirmVerifyDocMsg: 'Do you want to verify this document?',
      confirmApproveAndSignDocMsg: 'Do you want to approve and sign this document?',
      confirmVerifyAndSignDocMsg: 'Do you want to verify and sign this document?',
      confirmSignDocMsg: 'Do you want to sign this document?',
      confirmSignDocMsg_plural: 'Do you want to sign these documents?',
      confirmRejectDocMsg: 'Do you want to reject this document?',
      confirmSendDocMsg: 'Do you want to send this document?',
      confirmArchiveDocMsg: 'Do you want to move this document to Archive?',
      confirmDeleteDocMsg: 'Do you want to move this document to Trash?',
      confirmHardDeleteDocMsg: 'Do you want to delete this document?',
      confirmRejectReasonLabel: 'Cancellation reason',
      confirmArchiveReasonLabel: 'Archivation reason',
      signRejectRequestDocument: 'Подпиши молба за прекратяване',
      signWithCodeLabel: 'Signing',
      signWithCodeMsg: 'Enter the two-factor authentication code from your application',
      signWithCodeMsgAndExitForm:
        'Enter the two-factor authentication code from your application. Please open and fill in the exit interview form.',
      confirmApproveDocLabel: 'Yes, Approve it!',
      confirmVerifyDocLabel: 'Yes! Verify',
      confirmApproveAndSignDocLabel: 'Yes! Approve and sign',
      confirmVerifyAndSignDocLabel: 'Yes! Verify and sign',
      confirmSignDocLabel: 'Yes, Sign it!',
      confirmRejectDocLabel: 'Yes, Reject it!',
      generateRejectDocument: 'Generate rejection order',
      generateRejectRequestDocument: 'Generate reject request',
      confirmRemoveDocLabel: 'Yes, Remove it!',
      confirmSendDocLabel: 'Yes, Send it!',
      confirmArchiveDocLabel: 'Yes, Move it!',
      confirmDeleteDocLabel: 'Yes, Move it!',
      confirmHardDeleteDocLabel: 'Yes, Delete it!',
      approvedDocSuccessMsg: 'The document has been approved.',
      approvedDocSuccessMsg_plural: 'The documents have been approved.',
      verifiedDocSuccessMsg: 'The document has been verified!',
      approvedAndSignedDocSuccessMsg: 'The document has been approved and signed!',
      verifiedAndSignedDocSuccessMsg: 'The document has been verified and signed!',
      signedDocSuccessMsg: 'The document has been signed.',
      signedDocSuccessMsg_plural: 'The documents have been signed.',
      rejectedDocSuccessMsg: 'The document has been rejected.',
      sentDocSuccessMsg: 'The document has been sent.',
      archivedDocSuccessMsg: 'The document has been moved to Archive.',
      deletedDocSuccessMsg: 'The document has been moved to Trash.',
      hardDeletedDocSuccessMsg: 'The document has been deleted.',
      hardDeletedDocSuccessMsg_plural: 'The documents have been deleted.',
      notificationSent: 'The notification has been sent',
      multiActions: 'Multi actions',
      multiApprove: 'Multi approve/verify',
      multiSend: 'Multi send',
      multiSign: 'Multi sign',
      noDocsSelected: "You haven't selected any documents.",
      confirmDocsAware: 'Are you sure you are familiar with this document?',
      confirmDocsAware_plural: 'Are you sure you are familiar with these documents?',
      docActionsInProgress: 'Document actions in progress.',
      docViewInformation: 'View document information',
      docFromLeavesFeature: 'Document related to leaves, for more information check menu "Leaves"',
      massDocShort: 'Mass doc.',
      massDoc: 'Mass document',
      viewAllEmployees: 'View all employees',
      documentFor: 'Document for:',
      sendAndOrArchive: 'Send and/or archive a document',
      filtersBtn: 'Filters',
      hiddenLeaveDocuments:
        'Documents related to leaves, created from the menu "Leaves", are hidden. Click to show them.',
      notHiddenLeaveDocuments:
        'Documents related to leaves, created from the menu "Leaves", are shown. Click to hide them.',
      hiddenWorkTripDocuments: 'Documents related to work trips are hidden. Click to show them.',
      notHiddenWorkTripDocuments: 'Documents related to work trips are shown. Click to hide them.',
      showOnlyWaitingAction: 'Show all documents expecting actions from the employer.',
      showAllDocuments: 'Click to view only documents expecting actions from you.',
      archivedOn: 'Archived on',
      documentHolder: '№ doc. package',
      documentID: '№ doc.',
      hiddenHealthAndSafetyDocuments:
        'Documents related to health and safety trainings are hidden. Click to show them.',
      notHiddenHealthAndSafetyDocuments:
        'Documents related to health and safety training are shown. Click to hide them.',
      editFromFields: 'Edit (from dynamic fields, will NOT keep previous manual text changes)',
      editFromText: 'Edit (from text, will keep manual text changes)',
      download: 'Download',
      massDownload: 'Mass Download',
      delete: 'Delete',
    },
    activity: {
      action: 'Action',
      number: 'Number',
      description: 'Description',
      date: 'Date',
      receipt: 'Receipt',
      backToDocsList: "Back to documents' list",
      backToReports: 'Back to reports',
      docFilter: 'Document',
      userFilter: 'Employee',
    },
    bulkDownload: {
      preparing: 'Preparing Download',
      pleaseWait: 'Please wait while we prepare your documents...',
      immediateDownloadMessage:
        "Your documents are being downloaded, please check your browser's Downloads folder.\n\nIf the files are missing, check if your browser is blocking the downloads.\n\nIf you want to download an archive - download 11 or more files.",
      archiveGenerating: 'Archive is being generated',
      archiveMessage:
        'When ready, you will receive an email notification, and it will be available in the Archives menu (top right). Download links for generated archives are valid for 10 minutes.',
      error:
        'An error occurred while preparing the download. Please try again with different documents, or later.\n\nIf the problem persists - contact us at support@ehr.bg',
      tooltip:
        'When selecting up to 10 documents, individual files will be downloaded. For more, a zip archive will be generated',
    },
  },
  structure: {
    title: 'Manage structure',
    overtime: {
      employee: 'Employee',
      group: 'Group',
      day_work: 'Working on',
      day_off: 'Day off',
      actions: 'Actions',
      selectEmployee: 'Select employee',
      workAtDate: 'Will work on',
      restAtDate: 'Will rest on',
      workingHours: 'Working hours',
      confirmDocHeading: 'Are you sure?',
      confirmRejectDocMsg: 'Do you want to reject this working day?',
      confirmRejectDocLabel: 'Yes! Reject it',
      cancel: 'Cancel',
      submit: 'Submit',
      overtimeHeading: 'Add working day',
      rejectedOvertimeSuccessMsg: 'The working day has been rejected',
      overtimeView: 'Add working days',
      addSuccessMsg: 'The working day has been added',
      fullDay: 'Full day',
      hourly: 'Hourly',
      type: 'Rest type',
      hoursOfRestPerDay: 'Hours of rest per day',
      startRestingAt: 'Will start resting at',
      restInTwoDays: 'Leaves for 2 days',
      hoursSmall: 'h.',
    },
    groups: {
      title: 'Groups',
      addBtnLabel: 'Create group',
      name: 'Name',
      address: 'Address',
      description: 'Description',
      visibleToCandidates: 'Visible to candidates',
      createTitle: 'Create a group',
      createSuccessMsg: 'Group created',
      editTitle: 'Edit group',
      employees: 'Employees in this group',
      moderators: 'Moderators with access to this group',
      editSuccessMsg: 'Group updated',
      deleteSuccessMsg: 'Group deleted.',
      deleteConfirmTitle: 'Delete group',
      deleteConfirmMsg: 'Do you want to delete this group?',
    },
    roles: {
      title: 'Roles',
      addBtnLabel: 'Create a role',
      name: 'Name',
      createTitle: 'Create a role',
      createSuccessMsg: 'Role created',
      editTitle: 'Edit role',
      editSuccessMsg: 'Role updated',
      deleteSuccessMsg: 'Role deleted.',
      deleteConfirmTitle: 'Delete role',
      deleteConfirmMsg: 'Do you want to delete this role?',
      employees: 'Employees with this role',
    },
    employees: {
      title: 'User',
      addBtnLabel: 'Create user',
      name: 'Име',
      name_en: 'Name',
      middleName: 'Презиме',
      middleName_en: 'Middle name',
      lastName: 'Фамилия',
      lastName_en: 'Last name',
      type: 'User type',
      createdAt: 'Registration date',
      status: 'Status',
      twoFaStatus: 'Two-factor authentication',
      active: 'Active',
      inactive: 'Inactive',
      groups: 'Groups',
      mainGroup: 'Main group',
      groupRights: 'Group-access rights',
      roles: 'Roles',
      allRoles: 'Roles',
      approveDocs: 'Approve documents',
      signDocs: 'Sign documents',
      manageEmployees: 'Manage employees',
      manageModerators: 'Manage moderators',
      manageGroups: 'Manage groups',
      manageRoles: 'Manage roles',
      manageDocPermissions: 'Manage document permissions',
      manageHealthAndSafetyTraining: 'Manage health and safety training',
      manageWorkTrips: 'Manage work trips',
      manageLeaves: 'Manage leaves',
      viewSensitiveFieldsOnUserDataReport: 'Access to sensitive data in employee data report.',
      approveDocsDesc: 'Can approve documents (only if appropriate permissions by role and document category are set).',
      signDocsDesc: 'Can sign (only if appropriate permissions by role and document category are set).',
      manageEmployeesDesc: 'Can create, edit and manage employee users.',
      manageModeratorsDesc: 'Can manage permissions for moderator and combined users.',
      manageGroupsDesc: 'Can create and manage employee groups.',
      manageRolesDesc: 'Can create and manage roles.',
      manageDocPermissionsDesc: 'Can manage approval and signing levels for document categories.',
      manageLeavesDesc:
        'Can access leaves module (actions are available only if other appropriate permissions are given).',
      manageHealthAndSafetyTrainingDesc: 'Can manage health and safety trainings.',
      manageWorkTripsDesc: 'Can access the employee work trips module.',
      downloadUserDataReportDesc: 'Can generate and download employee data report.',
      viewSensitiveFieldsOnUserDataReportDesc:
        'Can view sensitive data in employee report - Personal ID number (EGN) ' +
        'ID card number/issued at/from, Mobile phone, Salary, Permanent and Current address.',
      egn: 'Personal identification number',
      dateOfBirth: 'Date of birth',
      IDCardNumber: 'ID card number',
      IDCardNumberHint: '9 digits. For IDs after June 2024 - 2 English letters, followed by 7 digits.',
      IDCardIssuedAt: 'ID card issued on',
      IDCardExpiresAt: 'ID card expires on',
      IDCardIssuedInCity: 'Л.к. от МВР - град',
      IDCardIssuedInCity_en: 'ID card issued at',
      education: 'Education',
      educationalLevel: 'Educational level',
      legalRelationship: 'Legal relationship',
      directorate: 'Directorate',
      department: 'Department',
      administrativeUnit: 'Administrative unit',
      positionLevel: 'Position level',
      positionLevelLeading: 'Leading position level',
      positionLevelExpert: 'Expert position level',
      positionLevelSpecialist: 'Specialist position level',
      positionLevelKDA: 'Наименование на длъжността според КДА',
      rang: 'Rank',
      monthlySalaryLevel: 'Monthly salary level',
      monthlySalaryLevelDegree: 'Monthly salary level degree',
      address: 'Постоянен адрес',
      address_en: 'Permanent address',
      currentAddress: 'Настоящ адрес',
      currentAddress_en: 'Current address',
      mobilePhone: 'Mobile phone',
      mobilePhoneHint: 'Mobile phone should be written with the corresponding country code. For example: +359...',
      position: 'Длъжност',
      position_en: 'Occupation',
      nkpdCode: 'National classification of the professions and positions code (NKPP code)',
      grossSalary: 'Basic remunerations (EUR)',
      grossSalaryHint: 'Enter the basic salary of the employee in euro. Only digits should be used. For example: 850',
      grossSalaryMunicipality: 'Individual monthly remunerations',
      bonus: 'Additional remuneration for length of service and professional experience',
      bonusHint:
        'Only digits allowed. The minimum amount of the remuneration is 0.6 on top of the basic ' +
        'remuneration. For example: 0.6 or bigger digit.',
      paymentDeadline: 'Payment deadline',
      paymentDeadlineHint: 'Enter the date of the month by which the remuneration shall be paid. For example 20th.',
      workingHours: 'Working hours',
      workingHoursHint: 'Working day duration',
      placeOfWork: 'Място на работа',
      placeOfWork_en: 'Place of work',
      placeOfWorkHint: 'Посочва се населеното място, в което следва да се полага труда. Например: гр. София',
      placeOfWorkHint_en: 'Enter location in which the work shall be provided. For example: Sofia ',
      workingPlace: 'Работно място',
      workingPlace_en: 'Working place',
      annualLeaves: 'Annual paid leave days',
      leaveDaysPerYear: 'Paid leave days by years',
      mainLeaves: 'Regular annual paid leave',
      mainLeavesHint: 'Enter the number of days for regular annual paid leave. Use digits only. ',
      additionalLeaves: 'Additional annual paid leave',
      additionalLeavesHint: 'Enter the number of additional paid leave. Use digits only.',
      additionalLeavesHintForEditedField:
        'Please make sure that for the changes made to the paid leave, the necessary documents are or will be created.',
      additionalEmailHint:
        'You are making a change to the email that the employee receives notifications regarding his labour file. Make sure the e-document exchange agreement with the employee is up to date, or sign an annex to change their email (available in category "Other documents")',
      noticeDeadline: 'Termination notice period',
      mainGroupWarning: "The employee's primary group has been removed!",
      probationPeriod: 'Probation period',
      duration: 'Duration',
      inFavorOf: 'In favour of',
      contractNumber: 'Contract number',
      other: 'Друго',
      other_en: 'Other',
      otherInfo: 'Other information',
      representative: 'Representative',
      representativeHint: 'Mark this manager as employer representative',
      representativeMunicipalityHint: 'Mark this mayor as representative',
      twoFaReset: 'Restart two-factor authentication',
      createTitle: 'Create employee',
      createSuccessMsg: 'You created employee',
      editTitle: 'Edit employee',
      editSuccessMsg: 'You updated employee',
      importTitle: 'Import employees',
      firstWorkingDay: 'First working day',
      lastWorkingDay: 'Last working day',
      accessToSensitiveData: 'Access to sensitive data',
      manageRights: 'Manage rights by category',
      manageGroupRoleLimits: 'Manage group and role limits',
      rolesTableInfo:
        "You can change the user's access to categories by pressing the yes/no buttons. There is no option to remove access to all groups.",
      backToEdit: '< Back to full user edit',
      limitedAccess: 'Additional category limit',
      leaveDaysServedTime: 'Usable leave days for served time',
      leaveDaysIrregularWorkingHours: 'Usable leave days for irregular working hours',
      leaveDaysSpecificWorkingConditions: 'Usable leave days for specific working conditions',
      leaveDaysAdditionalLeave: 'Usable additional leave days',
      leavesWfh: 'Number of days working from home',
      perWeek: 'per week',
      perMonth: 'per month',
      alwaysEligibleAsSubstitute: 'Always eligible as substitute',
      releasedStatusValidation: {
        emptyDateTitle: 'Confirm "Released" Status',
        emptyDateMessage:
          'You are changing this user status to "Released", but you have not explicitly specified the "Last working day". This may lead to incorrect information in future reports. Would you like to:',
        emptyDateUseToday: "Have eHR automatically use today's date",
        emptyDateManualEdit: 'Enter date manually',
        emptyDateLeaveEmpty: 'Leave the field empty',
        pastDateTitle: 'Confirm "Released" Status',
        pastDateMessage:
          'You are changing this user status to "Released", but the specified "Last working day" is in the past. This may lead to incorrect information in future reports.',
        pastDateConfirm: 'Information is correct, Save',
        pastDateEdit: 'I want to edit, Cancel',
        futureDateTitle: 'Confirm "Released" Status',
        futureDateMessage:
          'You are changing this user status to "Released", but the specified "Last working day" is in the future. After changing status to "Released" now, the user will no longer have access to eHR, but you may be expecting actions from them.',
        futureDateConfirm: 'Information is correct, Save',
        futureDateEdit: 'I want to edit, Cancel',
      },
      calculateLeaveBtn: 'Calculate leave',
      calculateLeaveBtnHint:
        'The following fields must be completed: Working hours (value and per day/week/month), Regular annual paid leave and First working day. eHR is not responsible for incorrectly entered data.',
      leaveDaysTooltip:
        "This field can be filled in manually or calculated automatically using the Calculate Leave button. The paid leave days for the year are determined proportionally based on the default Annual paid leave, start date, and the employee's working hours.",
    },
    scenarios: {
      title: 'Permissions',
      category: 'Category',
      createDocs: 'Create documents',
      approveDocs: 'Approve documents',
      signDocs: 'Sign documents',
      sendAndArchiveDocs: 'Send and archive documents',
      notify: 'Document status notification',
      manageLeaves: 'Manage leaves',
      confirmMassChange: 'Do you want to apply these changes to all categories in this column?',
      confirmContent:
        'Confirm removing these permissions. ' +
        'This action will also remove the corresponding configured approvе and sign levels',
    },
    multiActions: {
      title: 'Approve and sign',
      number: 'Number',
      docName: 'Document name',
      type: 'Type',
      approvals: 'Approvals',
      approvalNotRequired: 'Approval not required',
      signatures: 'Signatures',
      signNotRequired: 'Signature not required',
      defaultBehaviour: 'Choose default behaviour for documents in this category',
    },
  },
  reports: {
    title: 'Create a report',
    documents: 'Documents',
    documentsByAction: 'Documents by action',
    leaves: 'Leaves',
    leavesDetailed: 'Summary report of leaves',
    leavesFormSixtySeven: 'Form 76',
    leavesList: 'Detailed report of individual leaves',
    leavesAvailability: 'Available paid leave days per employee',
    employeeData: 'Employee data',
    municipality: 'Municipality',
    categories: 'Categories',
    groups: 'Groups',
    docName: 'Document name',
    employees: 'Employees',
    author: 'Author',
    fromDate: 'From date',
    toDate: 'To date',
    leaveType: 'Leave type',
    leaveStatus: 'Leave status',
    submitBtn: 'Generate report',
    downloadReport: 'Download generated report',
    downloadLeavesReport: 'Download report',
    downloadEmployeeDataReport: 'Download report',
    downloadWorkTripsDataReport: 'Download detailed report',
    employeeStatus: 'Employee status',
    expandAll: 'Expand the calendar and show all leaves',
    collapseAll: 'Collapse the calendar and show limited number of leaves',
    actions: 'Actions',
    actionDate: 'Action date',
    downloadXML: 'Download report for import in Microinvest (XML)',
    leaveStatistics: 'Data from this XML report:',
    leavesCount: 'Total leaves count',
    manuallyAdded: 'Manually added leaves',
    hasOverlappingLeavesForSameEmployee: 'Overlapping leaves for the same employee',
    paidleaveDaysCurr: 'Paid leave days (from available for current year)',
    paidleaveDaysPrev: 'Paid leave days (from available for previous years)',
    paidleaveDays157: 'Paid leave days under art. 157',
    unpaidLeaveDays: 'Unpaid leave days',
    overlappingLeaves: 'Names of employees with overlapping leaves',
    hourlyAbsences: 'Hourly absences',
    workTrips: 'Work trips',
    viewDocumentsByAction: 'Preview report',
    downloadDocumentsByAction: 'Download report',
    viewLeavesAvailabilityReport: 'Preview report',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    position: 'Position',
    group: 'Group',
    status: 'Status',
    leavesAvailabilityServedTime: 'Leave days served time',
    leavesAvailabilityAdditional: 'Paid additional leave',
    leavesAvailabilityIrregularWorkingHours: 'Paid leave - irregular working hours',
    leavesAvailabilitySpecificWorkingConditions: 'Paid leave - specific working conditions',
    healthAndSafetyTraining: 'H & S training',
    downloadAladdin: 'Aladdin report',
    downloadBusinessNavigator: 'Business Navigator report',
    businessNavigatorDownloadInfo:
      'Please confirm that all leave actions for the month have been completed before importing the data',
    downloadStil: 'STIL report',
    noLeavesAndSick: 'The report does NOT include sick leave and work from home',
    noEmployeeDocumentsOrAccess:
      'There are no created documents for the selected employee, or you do not have access to them.',
  },
  fileUploader: {
    dropFiles: 'Drop files here.',
    placeholder: 'Drop files here or click to choose file.',
    hint: 'Allowed file extensions: {{accept}}',
    duplicatedFile: 'File duplicated - {{name}}.',
    tooLargeFile: 'The file you are trying to upload is too large. The maximum file size is 20 MB.',
    approveUploadedFile: 'By signing this form, you declare that the attached files are genuine',
    noNeedToApproveUploadedFile:
      'By signing this form, you declare that you will provide the sick leave document to the employer outside of eHR',
    approvePaidLeaveUploadedFile: 'Requesting that type of paid leave requires attaching а document to justify it.',
  },
  docWizard: {
    title: 'Create document',
    editTitle: 'Edit document',
    operatorMessage: 'Operators cannot create documents',
    prevStep: 'Previous step',
    nextStep: 'Next step',
    saveDoc: 'Save document',
    editBtn: 'Change the name of the document folder',
    step1: {
      title: 'Form',
      description: 'Choose document',
      massDoc: 'Mass document',
      docType: 'Document type',
      docCategory: 'Category',
      docTemplate: 'Document',
      docGroup: 'Group',
      docEmployee: 'Employee',
      externalTitle: 'Form',
      externalDescription: 'Choose employee and document category',
      systemDocTemplates: 'Document templates',
      externalDocs: 'External documents',
      selected: 'Selected',
      leaves: 'Leaves',
      showLeavesInfoTextForEmployer: `If you are doing any changes to the employee paid leave
        days, please apply them manually in their profile too.`,
      showLeavesInfoTextForEmployee: 'Please request leave via <a>menu Leave</a>.',
      select: 'Select',
      deselect: 'Deselect',
      selectOnlyActive: 'Select only active',
    },
    step2: {
      title: 'Configuration',
      description: 'Document settings',
    },
    step3: {
      title: 'Information',
      description: 'Provide information',
      fieldsTitle: 'Fill in the fields needed to create a document',
      fieldsEditTitle: 'Fill in the fields needed to edit a document',
      missingFieldsText: 'Този документ няма налични полета за редакция, моля преминете към следващата стъпка.',
      attachDocuments: 'Attach additional documents',
      externalTitle: 'Files',
      externalDescription: 'Uploading/Adding scanned documents',
      multiUserWarning:
        'Above this line you see the fields that will have the same content in each document.</br>Below it you see each selected employee and you can fill in their specific data.',
    },
    step4: {
      title: 'Preview',
      close: 'Close',
      description: 'Document preview and apply changes if needed',
      descriptionShort: 'Preview and apply changes',
      editDocBeforeSave: 'Edit before saving',
      docWatermarkText:
        'Document with number: {{number}} has been generated in eHR.bg system on {{nowDate}} by {{name}}',
      docWatermarkText_lang2:
        'Документ с Номер: {{number}} е генериран от системата eHR.bg на {{nowDate}} от потребител {{name}}',
      massDocWatermarkText: 'Mass document has been generated in eHR.bg system on {{nowDate}} by {{name}}',
      massDocWatermarkText_lang2:
        'Масов документ е генериран от системата eHR.bg на {{nowDate}} от потребител {{name}}',
      saveDocChanges: 'Save changes',
      discardDocChanges: 'Discard changes',
      multilingualHintText: 'See english version below.',
    },
    step5: {
      title: 'Finalize',
      description: 'Save and approve',
      storagePeriod: 'Storage period',
      storageDate: 'Storage date',
      docScenario: 'Document action',
      approveAndSignLevels: 'Required approvals and signatures:',
      notifyForStatusUpdate: 'People to notify about document actions:',
      confirmSubmissionHeading: 'Are you sure?',
      confirmSubmissionMessage: 'You will mass create documents for {{count}} employees!',
      confirmSubmissionLabel: 'Yes, create!',
      confirmMassChangeHeading: 'Are you sure?',
      confirmMassChangeMessage:
        'Do you want to apply the storage period and document action for all external documents from the package?',
      confirmMassChangeLabel: 'Yes, change them!',
      saveWithOption: 'Save with option for mass change',
      editWithOption: 'Edit with option for mass change',
      successMsgHeading: 'Successful action!',
      successMsgMulti:
        'You have created documents for {{count}} employees.</br>It may take some time to complete the creation.</br>If you do not see a document, please try again in a moment.',
      successMsgSingle: 'You have created a document',
      loadingHeading: 'Please wait',
      loadingMsg: 'Creating documents...',
      exitInterview: {
        prompt: 'Do you wish to take an exit interview?',
        promptAccept: 'Yes, create document and take interview',
        promptReject: 'No, only create document',
      },
    },
  },
  profile: {
    title: 'Profile settings',
    personalInfo: 'Personal information',
    name: 'Name',
    email: 'E-mail',
    changePassword: 'Change password',
    currentPass: 'Current password',
    pass: 'Password',
    passHint:
      'Must be at least 10 characters long and contain lowercase ' +
      'letter, uppercase letter, a number and a special symbol.',
    confirmPass: 'Confirm password',
    code: 'Confirmation code',
    codeHint: 'Enter two-factor authentication code.',
    feVersion: 'Current Front-End Version:',
  },
  twoFA: {
    title: 'Two-factor authentication',
    activateTitle: 'Activate two-factor authentication',
    instructions: 'Instructions',
    QRcode: 'Scan and verify QR code',
    manualVerification: 'Manual verification',
    activationSuccessMsg: 'You activated your two-factor authentication.',
    activate: 'Activate',
    code: 'Code',
    codeHint: 'Verification code',
    restartBtn: 'Restart two-factor authentication',
    confirmTitle: 'Are you sure?',
    confirmMsg: 'Do you want to remove two-factor authentication?',
    removeBtn: 'Remove',
    warning: 'The code may not be valid, because of inaccurate date and time on your phone.',
    instuctions: {
      title: 'Instructions on how to check/fix that here.',
      heading: 'Setup Guide',
      step1: 'A) Open the menu in the top left corner',
      step2: 'B) Click "Settings"',
      step3: 'C) Click "Time correction for codes"',
      step4: 'D) Click "Sync now"',
      step5: 'E) You should see a message "Time already correct"',
      step6: 'F) Click the OK button and try to input the code again.',
    },
  },
  leaves: {
    leaves: 'Leaves',
    noLeaves: 'No leaves yet',
    otherLeaves: 'Others',
    attendantTooltip: 'Change the value to, see "attendance" info',
    deleteConfirmation: 'Are you sure you want to delete the selected leave?',
    colleagueTitle: 'Colleague leaves',
    deleteHeading: 'Delete manually added leave',
    step: 'Step',
    signRejectDocument: 'Sign reject document',
    signRejectRequestDocument: 'Sign reject request document',
    title: 'Paid time off / Sick leave',
    details: 'Details',
    titleManuallyInsert: 'Manually insert leave',
    attachmentsList: 'Attachments list',
    requestDocPreview: 'Request preview',
    orderDocPreview: 'Order preview',
    rejectionRequestDocPreview: 'Rejection Request Preview',
    createTitle: 'New Paid / Unpaid / Sick leave request',
    createTitleWFH: 'New Paid / Unpaid / Sick leave request / Work from home',
    createTitleWFO: 'New Paid / Unpaid / Sick leave request / Work from home / work from office',
    previousTitle: 'Information about previous leaves',
    note: 'Paid days off left: ',
    noteTimeServed: 'Paid days off left for served time: ',
    noteAdditionalLeave: 'Paid days off left for additional leave: ',
    noteWfhWeekly: 'Work from home days left for current week: ',
    noteWfhMonthly: 'Work from home days left for current month: ',
    tooltipFutureYear: 'These leave days cannot be used for the current year',
    addLeaveBtn: 'New leave request',
    type: 'Type of Leave',
    typeShort: 'Type',
    subType: 'Sub type of Leave',
    subTypeShort: 'Sub type',
    substituteEmployee: 'Substitute employee',
    substituteEmployeeManual: 'Substitute employee',
    filterReview: 'Filter by review status',
    filterReviewDeselected: 'Filter by review status',
    dateFromTo: 'Start date - End date',
    dateFrom: 'Start date',
    fromInterrupted: 'From',
    toInterrupted: 'To',
    dateRange: 'Date range',
    insertType: 'Insert type',
    insertTypeManually: 'Manually',
    dateTo: 'End date',
    requestDocumentId: 'Request document ID',
    requestDocumentComment: 'The ID should be of an existing and accessible document.',
    orderDocumentId: 'Order document ID',
    orderDocumentComment:
      'The ID should be of an existing and accessible document. It can be the same as of the request.',
    commentInfoManual: 'The comment will be visible by the employee.',
    year: 'Year',
    userCount: 'Active users count',
    numberOfDays: 'Number of days',
    group: 'Group',
    status: 'Status',
    month: 'Month',
    paid: 'Paid leave',
    additional: 'Additional leave',
    work_from_home: 'Work from home',
    work_from_office: 'Work from office',
    otherPaid: 'Other paid leave',
    unpaid: 'Unpaid leave',
    sick: 'Sick leave',
    paid_ordinary: 'Standard',
    paid_blood_donation: 'Blood donation - Art. 157 (1)(2)',
    paid_marriage: 'Marriage - Art. 157 (1)(1)',
    paid_death: 'Deceased relative - Art. 157 (1)(3)',
    paid_served_time: 'Served Time',
    paid_maternity: 'Maternity',
    paid_paternity: 'Paternity',
    paid_training: 'Training',
    paid_ordinary_hint: 'Art. 155, para. 1 from Labour Code',
    paid_blood_donation_hint: 'Art. 157, para. 1, item 2 from Labour Code',
    paid_marriage_hint: 'Art. 157, para. 1, item 1 from Labour Code',
    paid_death_hint: 'Art. 157, para. 1, item 3 from Labour Code',
    irregular_working_hours_hint: 'Art. 156, para. 1, item 2 from Labour Code',
    specific_working_conditions_hint: 'Art. 156, para. 1, item 1 from Labour Code',
    court_summons_hint: 'Art. 157, para. 1, item 4 from Labour Code',
    paidShort: 'P',
    unpaidShort: 'U',
    additionalShort: 'А',
    sickShort: 'S',
    annualTitle: 'Annual leaves',
    upcomingTitle: 'Upcoming leaves',
    previousLeavesInfo: 'Detailed information about past leaves',
    createSuccessMsg: 'Your leaves request was successful',
    rejectRequestSuccessMsg: 'Your leaves request for rejection was successful',
    initiated: 'Initiated',
    inprogress: 'In progress',
    employeeRejectInitiated: 'Pending rejection',
    interrupted: 'Interrupted',
    confirmEmployeeRejection: 'Confirm rejection request',
    manuallyInsertLeave: 'Manually insert leave',
    manuallyEditLeave: 'Manually edit leave',
    manuallyEditLeaveCreate: 'Edit leave',
    manuallyInsertLeaveCreate: 'Create leave record for employee',
    manuallyInsertedLeave: 'You have created a leave record for the employee',
    manuallyEditedLeave: 'You have edited a leave record for the employee',
    takePaidLeaveDays: 'Substract the number from the available for the employee',
    manuallyInsertLeaveCreateConfirmation:
      'By creating this leave, you assume responsibility that the necessary documents are issued and signed for it and the employee is notified.',
    manuallyEditLeaveCreateConfirmation:
      'By editing this leave, you assume responsibility that the necessary documents are issued and signed for it and the employee is notified.',
    pending: 'Pending',
    signing: 'Signing',
    confirmed: 'Approved',
    approve: 'Approved',
    approved: 'Awaiting signature',
    signed: 'Signed',
    successfullyApproved: 'Successfully Approved',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    successMsg: 'Your leaves request has been deleted',
    confirmHeading: 'Deleting a request',
    confirmMsg: 'Are you sure you want to delete the selected document?',
    confirmNotEnoughDaysHeading: 'Are you sure?',
    confirmNotEnoughDaysMsg:
      'This employee currently has no days of paid leave available - leave is for {{paidDaysCount}} days, the employee has a total of {{remainingDays}} days. The possible reason is that he has declared several absences at once and other leave(s) have already used the days. Do you still wish to sign this leave?',
    notEnoughDaysMsg:
      'Currently, this employee does not have days of paid leave available - the leave is for more days than the employee has in total. The possible reason is that he has declared several absences at once and other leave(s) have already used the days. You can only perform the action once.',
    holiday: 'Holiday',
    comment: 'Comment',
    noComment: 'No comment',
    commentInfo: 'Your comment will be visible by the employer',
    from: 'from',
    fromYear: 'From',
    used: 'are used',
    on: 'on',
    yearShort: 'y.',
    yearShortOnlyBG: '',
    day: 'day',
    days: 'days',
    hoursSmall: 'h.',
    eSign: 'E-sign',
    eSignSubtitle: 'Loading signature certificates',
    confirmLeaveAware: 'Are you sure you are familiar with the selected leaves?',
    confirmApproveLeaveMsg: 'Do you want to approve the selected leaves?',
    confirmSignLeaveMsg: 'Do you want to sign the selected leaves?',
    requesytedHalfDay: 'Requested a half day',
    requestHalfDay: 'Request a half day',
    portionOfDay: 'Part of the day',
    firstPortionOfDay: 'First half of the day',
    secondPortionOfDay: 'Second half of the day',
    requestLeave: 'Request leave',
    integerRequired: 'The field must be an integer number',
    monthTableWarning: 'You can only see data for groups/employees you have access to.',
    groupTableWarning: 'Sum of days may be higher, because of employees in more than one group.',
    generateRejectRequestDocument: 'Generate reject request ',
    rejectLeave: 'Reject leave',
    leaveRejectedSuccessMsg: 'The leave has been rejected',
    expand: 'Expand calendar and show all leaves',
    collapse: 'Collapse calendar and show limited number of leaves',
    allLeaves: 'All leaves',
    switchTo: 'Switch to',
    showGridView: 'View by days',
    showCalendarView: 'Calendar view',
    workTrips: 'Work trips',
    showWorkTrips: 'Show work trips',
    hideWorkTrips: 'Hide work trips',
    colleagueInfoMessage:
      'Here you see the holidays of the colleagues you share groups with. To manage the leaves of your teams,',
    switchWorkMode: 'go in {{workmode}} mode',
    multipleOfHalfRequired:
      'The field must be an integer or a floating point number multiple of 0.5, the value will be rounded to the nearest multiple of 0.5',
    interruptOverlapHeading: 'Overlapping Leave',
    interruptConfirmMsg: 'Do you want to interrupt the existing leave and continue?',
    interruptLoadingMsg: 'Interrupting the existing leave...',
    substituteEmployeeName: 'Substitute',
    rejectReason: 'Reject reason',
    tooltip: {
      id: 'Leave №{{id}}',
    },
    validation: {
      error: 'Validation Error',
      lockedLeaves: 'Has locked leaves pending approval.',
      exceedsPaidOrdinary:
        'No action will be taken for some leaves, {{user}} exceeds available paid ordinary days ({{available}} available, {{requested}} requested).',
      exceedsAdditional:
        'No action will be taken for some leaves, {{user}} exceeds available additional days ({{available}} available, {{requested}} requested).',
      exceedsServedTime:
        'No action will be taken for some leaves, {{user}} exceeds available served time days ({{available}} available, {{requested}} requested).',
      errorFetchingData: 'Error checking days. Please try again.',
      massAction: {
        approve: {
          header:
            'Upon signing, some leaves of the following users will not be processed en masse due to insufficient days available.',
        },
        sign: {
          header:
            'Some leaves of the following users will not be signed off en masse due to insufficient days available.',
        },
        paidType: 'Paid',
        servedTimeType: 'Served Time',
        additionalType: 'Additional',
        userFormat: '{{user}} - available {{available}}, requested total {{requested}}',
      },
    },
    actions: {
      title: 'Actions',
      approved: 'Approved',
      signed: 'Signed',
      rejected: 'Rejected',
      created: 'Created',
    },
    table: {
      multiActions: 'Multi actions',
      approval: 'Approval',
      signing: 'Signing',
      approve: 'Approve',
      sign: 'Sign',
    },
    legend: {
      paid: 'Paid',
      paidOrdinary: 'Other paid',
      unpaid: 'Unpaid',
      sick: 'Sick',
      additional: 'Additional',
      work_from_home: 'Work from home',
      work_from_office: 'Work from office',
      tooltip: 'Pale colors show leaves which are not confirmed',
      confirmed: 'Confirmed',
      notConfirmed: 'Not confirmed',
      waitingForConfirmation: 'Waiting for approval',
      homeConfirmed: 'Work from home',
      waitingHomeConfirmation: 'Work from home (not confirmed)',
      officeConfirmed: 'Work from office',
      waitingOfficeConfirmation: 'Work from office (not confirmed)',
    },
    months: {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    },
    employee: {
      confirmRejectConfirmedLeaveMsg: 'Do you want to reject this confirmed leave?',
    },
    employer: {
      calendarView: 'Calendar',
      statisticsView: 'Statistics',
      tableView: 'Table View',
      leavesTableView: 'Leaves waiting for approval',
      leavesTableCompletedView: 'Approved and rejected leaves',
      name: 'Name',
      confirmRejectLeaveMsg: 'Do you want to reject this leave request?',
      confirmLeaveRejectRequestMsg: 'Do you want to confirm the leave rejection',
      confirmRejectConfirmedLeaveMsg: 'Do you want to reject this confirmed leave?',

      rejectedLeaveSuccessMsg: 'The leave has been rejected',
      unprocessedLeavesWarning:
        'There are leaves from a previous period (between {{minDate}} and {{maxDate}}) for which actions have not been completed. Please filter for past dates and check',
      calendar: {
        allDay: 'All day',
        previous: 'Previous',
        next: 'Next',
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        agenda: 'Agenda',
        date: 'Date',
        time: 'Time',
        event: 'Event',
        showMore: '+ {{total}} more',
      },
    },
    grid: {
      employeeName: 'Employee',
      noEmployeesWithLeaves: 'No employees with leaves for the selected month',
      onlyEmployeesWithAbsence: 'Only employees with some type of leaves for the month are displayed',
      actionsHeading: 'Actions',
    },
    interruptionInfo: 'Interruption information',
    interruptedBy: 'Interrupted by',
    interrupts: 'This sick leave interrupts the following leaves',
    duration: 'Duration',
    id: 'ID',
  },
  healthAndSafetyTraining: {
    title: 'Health and safety training',
    titleShort: 'H&S training',
    create: 'Create training',
    user: 'Employee',
    users: 'Employees',
    type: 'Type',
    facilitator: 'Facilitator',
    status: 'Status',
    actions: 'Actions',
    documentNumber: 'Number',
    group: 'Group',
    groups: 'Groups',
    date: 'Date',
    isMassTraining: 'Mass training',
    selectedUsers: 'Selected',
    excludeUser: 'Deselect',
    includeUser: 'Select',
    confirmCreate: 'Are you sure you want to create the selected training?',
    confirmMassCreate: 'Are you sure you want to create this mass training?',
    success: 'The training has been created',
    massSuccess: 'The mass training has been created',
    downloadReport: 'Download Report',
    confirmSignMsg: 'Are you sure those health and safety trainings are done, and you want to sign them?',
    confirmDeleteHeading: 'Delete health and safety trainings',
    confirmDeleteMsg: 'Are you sure you want to delete those health and safety trainings?',
    confirmDeleteHeadingSingle: 'Delete health and safety training',
    confirmDeleteMsgSingle: 'Are you sure you want to delete these health and safety training?',
    deletedSuccessMsg: 'The health and safety training has been deleted!',
    deletedSuccessMsg_plural: 'The health and safety trainings have been deleted!',
    selectOnlyActive: 'Select only active',
    types: {
      initial: 'Initial',
      periodic: 'Periodic',
      emergency: 'Emergency',
      at_workplace: 'At workplace',
    },
    statuses: {
      created: 'Awaiting signature from instructor',
      signed_by_employer: 'Awaiting signature from employee',
      completed: 'Completed',
      rejected: 'Rejected',
    },
    tabs: {
      list: 'Waiting for action',
      completedList: 'Completed and rejected',
    },
  },
  workTrips: {
    title: 'Work trips',
    create: 'New work trip',
    createSuccess: 'Work trip was created successfully',
    confirmCreate: 'Are you sure you want to create this work trip?',
    tripIn: 'Work trip in',
    domestic: 'Bulgaria',
    foreign: 'Abroad',
    country: 'Country',
    user: 'Employee',
    group: 'Group',
    destination: 'Destination',
    city: 'City',
    route: 'Route',
    period: 'From - To',
    fromDate: 'Start date',
    toDate: 'End date',
    daysCount: 'Days',
    overnightStays: 'Overnight stays',
    higherDailyAllowance: 'Standard daily allowance',
    dailyAllowanceIncreasePercent: 'Increase percent (0-100%)',
    dailyAllowance: 'Daily allowance',
    dailyAllowanceRange: 'Allowed range: {{min}} to {{max}} EUR',
    task: 'Task',
    transportType: 'Transport type',
    transportDetails: 'Transport additional details',
    dailyAllowancePaymentType: 'Payment type - daily allowance',
    accommodationPaymentType: 'Payment type - accommodation',
    accommodationOvernightStaysType: 'Accommodation (Overnight stays)',
    accommodationAmount: 'Accommodation amount',
    accommodationAmountRange: 'Allowed range: up to {{max}} EUR',
    travelPaymentType: 'Payment type - travel',
    travelAmount: 'Travel amount',
    totalCost: 'Total cost',
    status: 'Status',
    actions: 'Actions',
    reportGenerate: 'Create report',
    reportCreateSuccess: 'Work trip report was created successfully',
    reportExplanation: 'Report for completed work trip activities',
    reportDifficulties: 'During task execution, I encountered the following difficulties',
    reportVehicleRegistrationNumber: 'Vehicle registration number',
    reportTravelInvoiceAmount: 'Total amount per attached travel document(s)',
    reportAccommodationInvoiceAmount: 'Total amount per attached accommodation document(s)',
    previewOrder: 'Preview order',
    previewReport: 'Preview report',
    previewReportDocuments: 'Preview report documents',
    confirmSignMsg: 'Are you sure you want to sign the selected work trips?',
    statuses: {
      created: 'Awaiting employer signature',
      signed_by_employer: 'Awaiting employee signature',
      awaiting_facilitation: 'Awaiting facilitation',
      signed_by_employee: 'Completed, awaiting report',
      report_created: 'Completed, awaiting employee signature',
      report_signed_by_employee: 'Completed, awaiting employer signature',
      report_signed_by_employer: 'Completed and reported',
      status_employer_signed: 'Awaiting employee signature',
      status_employee_signed: 'Completed, awaiting report',
    },
    tabs: {
      list: 'Upcoming and awaiting report',
      completedList: 'Completed and reported work trips',
      calendar: 'Calendar',
      report: 'Report',
    },
    legend: {
      awaitingSignature: 'Awaiting signature',
      awaitingReport: 'Awaiting report',
      completed: 'Completed',
    },
  },
  work_trips: {
    status_employer_signed: 'Awaiting employee signature',
    status_employee_signed: 'Completed, awaiting report',
    travel_payment_cash: 'cash',
    travel_payment_bank: 'bank transfer',
    travel_payment_expensed_to_hosting_party: 'expensed to hosting party',
  },
  hourlyAbsences: {
    title: 'Hourly absences',
    dateFrom: 'Start date and time',
    dateTo: 'End date and time',
    status: 'Status',
    employee: 'Employee',
    lunchbreak: 'Lunch break',
    noLunchBreak: 'None',
    lunchbreakHalf: '30 minutes',
    lunchbreakOne: '1 hour',
    group: 'Group',
    actions: 'Actions',
    name: 'Name',
    date: 'Date, hour from - to',
    hours: 'Hours',
    leaveApplied: 'Leave applied',
    yes: 'Yes',
    no: 'No',
    partialCovered: 'Partially — {{covered}} / {{total}} h.',
    create: 'Create hourly absence',
    createEmployee: 'Create hourly absence',
    confirmationMessage: 'Are you sure you want to create the selected hourly absence?',
    confirmationMessageEmployee: 'Are you sure you want to create the hourly absence?',
    confirm: 'Yes, create!',
    confirmEmployee: 'Yes, create!',
    createSuccess: 'The hourly absence has been created',
    createSuccessEmployee: 'The hourly absence has been created',
    requestMyHourlyAbsence: 'Request hourly absence',
    downloadReport: 'Download report',
    comment: 'Comment',
    commentInfoManual: 'The comment will be visible by the employee',
    commentInfoManualEmployee: 'The comment will be visible by the employer',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    inputs: {
      date: 'Date',
      timeFrom: 'From hour',
      timeTo: 'To hour',
    },
    confirmAbsence: {
      delete: 'Do you want to delete the selected hourly absence?',
      approve: 'Do you want to approve the selected hourly absence?',
      reject: 'Do you want to reject the selected hourly absence?',
    },
    statuses: {
      confirmed: 'Confirmed',
      pending: 'Pending',
      rejected: 'Rejected',
    },
    remainingHours: 'Remaining hours for hourly absences',
    hoursLabel: 'h.',
    uncoveredHours: 'Total uncovered hours',
    hoursAboutToBeCovered: 'Will be covered after leave approval',
  },
  documentScenarioInfo: {
    'I-1': 'To be signed by the employer, and after that by the employee',
    'I-2': 'Digitalize a paper document',
    'I-3': 'Approval and sign only by employee',
    'I-4': 'To be signed by the employee, and after that by the employer',
    'I-5': 'Approval and sign only by the employer',
    'II-1': 'Approval and signature by employer, then approval and signature by you, the employee',
    'II-2': 'Approval and signature by only you, the employee',
  },
  trainingMaterials: {
    pdfs: {
      manualBG: 'Manual in Bulgarian',
      manualEN: 'Manual in English',
      manualLeaves: 'Manual for leaves',
      moduleLeaves: 'Visual guide for leaves',
      moduleKep: 'Manual for setting up KEP',
    },
    videos: {
      employee: {
        accountActivation: {
          title: 'Account activation',
          description: 'The first part of the process of activating your account - choosing a password.',
        },
        enableTwoFA: {
          title: 'Enable two-factor authentication',
          description:
            'The second part of the process of activating your account - setting up two-factor authentication.',
        },
        requestLeave: {
          title: 'Request leave',
          description:
            'Description of the leave application and signing process, overview of upcoming and past leaves (and sick) two-factor authentication',
        },
        approvalAndSigningOfDocument: {
          title: 'Approval and signing of received document',
          description:
            'Description of the process of reviewing a received document, its approval and subsequent signing with the eHR embedded electronic signature',
        },
        createApprovalAndSigningOfDocument: {
          title: 'Create, approve and sign an external document',
          description: 'Description of uploading an external PDF file as a document in the system',
        },
        createApprovalAndSigningOfDocumentTemplate: {
          title: 'Create, approve and sign a document from a template',
          description:
            'Presentation of the functionality to create a document from the templates built into the system.',
        },
      },
      employer: {
        addLeaveManually: {
          title: 'Add leave manually',
          description:
            'Introducing the functionality to manually enter absence for an employee. Handy if you need to add an absence that has been (or will be) approved on paper.',
        },
        editLeave: {
          title: 'Edit leave',
          description: 'Possibility to edit manually entered absences through the above functionality.',
        },
        digitalizePaperDocument: {
          title: 'Digitalize a paper document',
          description: 'Presentation of the possibility of creating an electronic original of a paper document.',
        },
        bulkDocumentCreation: {
          title: 'Bulk document creation',
          description: 'Introducing bulk document creation functionality for employees from multiple groups.',
        },
        massApprovalAndSigning: {
          title: 'Mass approval and signing of leaves',
          description: 'Overview of leave mass approval and signing functionality.',
        },
      },
    },
  },
  archives: {
    title: 'Archives',
    status: 'Status',
    type: 'Type',
    fileName: 'File Name',
    createdAt: 'Created',
    downloading: 'Downloading...',
    download: 'Download',
    noArchives: 'No archives available',
    documents: 'documents',
    from: 'from',
    viewArchives: 'View Archives',
    archiveReady: 'Your archive is ready and available for download!',
    downloadError: 'Error downloading archive. Please try again.',
    invalidArchiveId: 'Invalid archive ID',
    preparingDownload: 'Preparing your download...',
    statusPending: 'Pending',
    statusGenerating: 'Generating (started on {{time}})',
    statusReadyForDownload: 'Ready (expires on {{time}})',
    statusExpired: 'Expired',
    types: {
      documentsTab: 'Documents',
      leavesTab: 'Leaves',
      reportsDocumentsTab: 'Reports Documents',
      reportsDocumentActionsTab: 'Reports Document Actions',
      healthAndSafetyTab: 'Health and Safety Training',
      workTripsTab: 'Work trips',
    },
  },
  errors: {
    noConnection:
      'It seems you have an unstable or no internet connection. Please wait, restart, or contact your provider/employer.',
    serverUnavailable:
      'It seems some of the eHR services are currently unavailable. Our team has already been notified - please try again later.',
  },
};

export default en;
